import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { FC } from 'react';

const fmtVoteCount = (count: number) => {
  const absCount = Math.abs(count);
  if (absCount < 1000) {
    return absCount;
  }
  if (absCount >= 1000 && absCount < 10000) {
    return `${parseFloat((absCount / 1000).toFixed(1))}K`;
  }
  return `${Math.floor(absCount / 1000)}K`;
};

interface VoteButtonProps {
  type: 'upvote' | 'downvote';
  voted: boolean;
  voteCount: number;
  onClick: () => void;
}

export const VoteButton: FC<VoteButtonProps> = ({
  voteCount,
  voted,
  onClick,
  type,
}) => {
  return (
    <button
      aria-label={`${voted && 'remove '}${type}`}
      className={clsx(
        'group relative flex flex-row gap-xs overflow-hidden rounded-[40px] p-xs py-s text-body2Regular s:py-xs',
        {
          'pr-s': type === 'upvote',
          'pl-s': type === 'downvote',
          'bg-neutral-200 text-neutral-800 hover:bg-neutral-300': !voted,
          'bg-green-light text-green-dark hover:text-green-medium':
            type === 'upvote' && voted,
          'bg-red-light text-red-dark hover:text-red-medium':
            type === 'downvote' && voted,
        }
      )}
      onClick={onClick}
    >
      <div className="absolute inset-0 group-hover:bg-[#0000001A]" />
      {type === 'upvote' && <ArrowUpIcon className="size-[20px]" />}
      <span role="note">{fmtVoteCount(voteCount)}</span>
      {type === 'downvote' && <ArrowDownIcon className="size-[20px]" />}
    </button>
  );
};
